<mat-card class="h-full">
    <mat-card-title>
        <div class="flex align-items-center justify-content-sb">
            <div class="f-item m-0 flex flex-column items-start">
                <h3 class="f-item m-0">{{ chartTitle }}</h3>
                <span *ngIf="chartSubheading" class="text-base sub-heading-color mt-1"> {{ chartSubheading }}</span>
            </div>
            <ng-container *ngIf="showMenu">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <ng-container *ngIf="menuType == 'print' && showExportMenuIcons; else dateFilter">
                        <button
                            mat-menu-item
                            (click)="
                                exportChart({
                                    extension: 'png',
                                    fileName: chartTitle
                                })
                            "
                        >
                            <span>Export PNG</span>
                            <a id="ar" href="#"></a>
                        </button>
                        <button
                            mat-menu-item
                            (click)="
                                exportChart({
                                    extension: 'pdf',
                                    fileName: chartTitle
                                })
                            "
                        >
                            <span>Export PDF</span>
                        </button>
                    </ng-container>

                    <ng-template #dateFilter>
                        <button mat-menu-item (click)="exportFilter('today')">
                            <span>Today</span>
                        </button>
                        <button mat-menu-item (click)="exportFilter('Week')">
                            <span>Week</span>
                        </button>
                        <button mat-menu-item (click)="exportFilter('Month')">
                            <span>Month</span>
                        </button>
                    </ng-template>
                </mat-menu>
            </ng-container>
        </div>
    </mat-card-title>
    <mat-card-content class="">
        <mat-divider></mat-divider>
        <div id="chartId" class="flex h-full flex-col flex-auto pt-3">
            <apx-chart
                class="flex-auto w-full"
                #chart
                [noData]="chartOptions.noData"
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [xaxis]="chartOptions.xaxis"
                [stroke]="chartOptions.stroke"
                [fill]="chartOptions.fill"
                [tooltip]="chartOptions.tooltip"
                [dataLabels]="chartOptions.dataLabels"
                [labels]="chartOptions.labels"
                [legend]="chartOptions.legend"
                [markers]="chartOptions.markers"
                [grid]="chartOptions.grid"
                [yaxis]="chartOptions.yaxis"
                [title]="chartOptions.title"
            ></apx-chart>
        </div>
    </mat-card-content>
</mat-card>
